


























































const defaultAutoSize: TextareaInputProps['autosize'] = {
  minRows: 11,
  maxRows: 11
}

import isMobile from 'piramis-js-utils/lib/isMobile'
import VueFullscreen, { component as Fullscreen } from 'vue-fullscreen'
import { Component, Prop, VModel, Mixins, Ref } from 'vue-property-decorator'

import { TextareaInputProps } from "../Pi/fields/TextareaInput/types";
import { InputFieldEmits } from '../Pi/mixins'
import VueFullscreenApi = VueFullscreen.VueFullscreenApi

@Component({
  components: {
    Fullscreen
  },
  methods: {
    isMobile,
  },
})
export default class TextareaCounter extends Mixins(InputFieldEmits) {
  @VModel() computedValue!: string | undefined

  @Prop({ type: Number }) readonly counter!: number

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Boolean, default: false }) readonly validateMarkup!: boolean

  @Prop({ type: Boolean, default: false }) readonly resizeable!: boolean

  @Prop({ type: Object, default: () => defaultAutoSize }) readonly autoSize!: TextareaInputProps['autosize']

  @Prop({ type: Boolean, default: false, required: false }) hasFullScreen!: boolean

  @Ref('fullscreen') readonly fullscreen!: VueFullscreenApi

  @Ref('counterToolbar') readonly counterToolbar!: HTMLDivElement

  isFullscreen = false

  get fullscreenToolbarHeight() {
    const toolbar = this.$refs['counterToolbar']

    if (toolbar && toolbar instanceof HTMLElement) {
      const height = toolbar.offsetHeight

      return `${ height }px`
    }

    return '1px'
  }

  get areaAutosize(): TextareaInputProps['autosize'] {
    if (typeof this.autoSize === 'object' && typeof defaultAutoSize === 'object') {
      return {
        minRows: this.autoSize?.minRows ?? defaultAutoSize.minRows,
        maxRows: this.autoSize?.maxRows ?? defaultAutoSize.maxRows
      }
    } else if (typeof this.autoSize === 'boolean') {
      return this.autoSize
    }

    return false
  }

  get dataCount(): string {
    if (this.computedValue !== undefined) {
      return `${ this.computedValue.length } / ${ this.counter }`
    }
    return ''
  }

  get isHtmlInModelInvalid(): boolean {
    const parser = new DOMParser()
    const modelWithRoot = '<div>' + this.computedValue + '</div>'
    const parsedHtml = parser.parseFromString(modelWithRoot, "application/xml")

    return !!parsedHtml.querySelector('parsererror');
  }

  toggle(): void {
    this.fullscreen.toggle()
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      html_markup_error: 'Разметка не валидна',
    })
    this.$i18n.mergeLocaleMessage('en', {
      html_markup_error: 'Markup is not valid',
    })
  }

}
